"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const mark_1 = require("./mark");
class Action extends mark_1.Mark {
    constructor(title, target, actionParameters) {
        super('action');
        this.title = title;
        this.target = target;
        this.actionParameters = actionParameters;
    }
    toJSON() {
        const actionMark = {
            type: this.type,
            attrs: {
                title: this.title,
                target: this.target
            }
        };
        if (this.actionParameters) {
            actionMark.attrs.parameters = this.actionParameters;
        }
        return actionMark;
    }
}
exports.Action = Action;
//# sourceMappingURL=action.js.map